module.exports = __webpack_public_path__ + "img/symbol_2.261fa146.png";